module.exports = __webpack_public_path__ + "src/assets/img/guestlist_one_deluxe1.daf25462.jpg";